import { StaticExportError } from './model';

export const PNG_MIME_TYPE = 'image/png';
export const PDF_MIME_TYPE = 'application/pdf';

export function encodePng(canvas: HTMLCanvasElement): Promise<Blob> {
  return new Promise((resolve, reject) => {
    try {
      canvas.toBlob((blob) => {
        if (blob) resolve(blob);
        else reject(new StaticExportError('encoding', 'Could not encode the PNG export.'));
      }, PNG_MIME_TYPE);
    } catch (cause) {
      const isSecurityError = cause instanceof DOMException && cause.name === 'SecurityError';
      reject(
        new StaticExportError(
          isSecurityError ? 'cors' : 'encoding',
          isSecurityError
            ? 'This basemap could not be included in the static export.'
            : 'Could not encode the PNG export.',
          { cause },
        ),
      );
    }
  });
}

export async function encodePdf(
  png: Blob,
  widthMm: number,
  heightMm: number,
  title: string,
): Promise<Blob> {
  try {
    const { PDFDocument } = await import('pdf-lib');
    const document = await PDFDocument.create();
    const widthPoints = (widthMm * 72) / 25.4;
    const heightPoints = (heightMm * 72) / 25.4;
    const page = document.addPage([widthPoints, heightPoints]);
    const { embedPdfRaster, drawPdfRaster } = await import('./pdfRaster');
    const image = await embedPdfRaster(document, png);
    drawPdfRaster(page, image, { x: 0, y: 0, width: widthPoints, height: heightPoints });
    document.setTitle(title);
    document.setProducer('Placeio Maps');
    const bytes = await document.save();
    return new Blob([bytes as Uint8Array<ArrayBuffer>], { type: PDF_MIME_TYPE });
  } catch (cause) {
    throw new StaticExportError('pdf', 'Could not create the PDF export.', { cause });
  }
}
